import React from "react";
import { useParams } from "react-router-dom";
import {
CalendarDays,
MapPin,
Building2,
Users,
ArrowRight,
} from "lucide-react";
import { useState } from "react";
import { UserRound, GraduationCap } from "lucide-react";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";


const AboutPage = () => {
const { slug } = useParams();
console.log("Current slug:", slug);
const [active, setActive] = useState(false);

switch (slug) {


case "registrar":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5 ">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Administration
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        REGISTRAR
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill text-lg mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    REGISTRAR
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>



    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
            <div className="relative max-w-md mx-auto">

                <div className="relative overflow-hidden rounded-[28px] shadow-xl">

                    <img src="/images/Registrar_new.jpeg" alt="Prof. Satpal Singh Bisht"
                        className="block w-full h-auto  object-contain object-top" />

                    <div className="bg-[#ef4949] text-white text-center px-2 py-2">

                        <h3 className="text-xl md:text-2xl font-bold font-serif font-gill">
                            Prof. Reetesh Sah
                        </h3>

                        <p className="mt-2 text-sm md:text-base font-medium font-gill">
                            Registrar
                        </p>

                    </div>

                </div>

            </div>

            {/* CONTENT */}
            <div>

                <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6 text-justify font-gill">
                    About Registrar
                </h2>
                <h6 className="font-bold text-[var(--ink)] mb-6 text-justify font-gill">
                    (Prof. Reetesh Sah, Ph.D. Professor of History, Kumaun University, Nainital)
                </h6>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                    Prof. Reetesh Sah is a senior academic and institutional leader with a distinguished record in
                    scholarship, university governance and research administration. He holds a Ph.D. in History and an
                    MBA in Human Resource Management, a combination that informs his integrated approach to academic
                    leadership and faculty development.

                </p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">A recipient of an ICHR
                    Research Fellowship and two national awards from the Ministry of Defence, Government of India, he
                    has successfully led five major funded research projects supported by INSA, UGC, ICHR, and the
                    Government of Uttarakhand.</p>




                <div className="mt-8 border-t border-gray-200">

                    {/* Registrar */}
                    <div className="flex items-center gap-3 py-5 border-b border-gray-200">
                        <div className="flex-shrink-0">
                            <UserRound className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 font-gill text-lg">
                            Registrar
                        </span>
                    </div>

                    {/* Qualification */}
                    <div className="flex items-center gap-3 py-5">
                        <div className="flex-shrink-0">
                            <GraduationCap className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 text-justify font-gill text-lg">
                            Ph.D. in History, MBA in Human Resource Management

                        </span>
                    </div>

                </div>



            </div>

        </div>
    </section>

    {/* HIGHLIGHTS */}
    <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">



            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">As a founding member of the
                    UGC–MMTTC, Kumaun University, Prof. Sah has been instrumental in faculty development and academic
                    quality assurance, contributions that helped the Centre achieve a national ranking of fourth among
                    all UGC–MMTTCs in India. </p>

                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">His governance portfolio
                    spans University P.R.O., Additional Director (IQAC), Editor of QUEST – the Journal of UGC-HRDC,
                    Assistant Dean (Students’ Welfare), Nodal Officer (Mission Karmayogi), President (Students’ Club),
                    Chief Editor (University Publicatons), and is a member of various statutory and advisory bodies. His
                    major prior administrative roles include Deputy Controller of Examinations, Proctor and
                    Superintendent of University Central Evaluation.</p>

                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">In addition to his university
                    roles, Prof. Sah contributes to public service and environmental governance. He is a Member of the
                    District Plantation Committee, Member of the District Forest Fire Committee, and a member of the
                    Technical Forestry Committee (TFC) of the Uttarakhand Forest Department, reflecting his commitment
                    to community engagement, environmental sustainability, and policy support.</p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">A prolific scholar, he has
                    authored six books, one monograph, and over fifty research papers, with publications through
                    internationally reputed publishers including Springer Nature. He has edited illustrated academic
                    volumes for the Government of Uttarakhand and Kumaun University, including for the visit of the
                    Hon’ble President of India.</p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">Prof. Sah has supervised
                    eleven Ph.D. scholars and extends his mentorship through co-guidance to an Indian Army Officer at
                    Amity University. His academic outreach spans invited lectures at ICCR and leading institutions
                    including BHU, JMI, Delhi University, NBU, Jadavpur University, Gujarat University, Kashmir
                    University, Calicut University, Punjab University, Chandigarh, DAVV, Indore and MANUU Hyderabad,
                    among others. He has also delivered training for civil services officers of Uttarakhand and Bihar at
                    the Uttarakhand Academy of Administration.</p>




            </div>


        </div>
    </section>
    <Footer />

</div>
);



case "finance-controller":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                        Administration
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                        Finance Controller
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill text-lg mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B]">
                    FINANCE CONTROLLER
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>



    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
            <div className="relative max-w-md mx-auto">

                <div className="relative overflow-hidden rounded-[28px] shadow-xl">

                    <img src="/images/finance_controller_1.jpeg" alt="Prof. Satpal Singh Bisht"
                        className="block w-full h-auto object-contain object-top" />

                    <div className="bg-[#ef4949] text-white text-center px-2 py-2">

                        <h3 className= "md:text-2xl font-bold font-gill text-lg">
                            Ms. Kamlesh Bhandari
                        </h3>

                        <p className="mt-2 md:text-base font-gill text-lg">
                            Finance Controller
                        </p>

                    </div>

                </div>

            </div>

            {/* CONTENT */}
            <div>

                <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6 font-gill text-lg">
                    About Finance Controller
                </h2>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                    Ms. Kamlesh Bhandari, the Finance Controller of Kumaun University, plays a pivotal role in managing
                    the financial affairs of the institution. With a keen eye for detail and a strong commitment to
                    fiscal responsibility, she ensures the effective allocation of resources, maintaining financial
                    stability and transparency in all university operations. Her expertise in financial management
                    significantly contributes to the smooth functioning and growth of Kumaun University.
                </p>


                <div className="mt-8 border-t border-gray-200">


                    <div className="flex items-center gap-3 py-5 border-b border-gray-200">
                        <div className="flex-shrink-0">
                            <UserRound className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 font-gill text-lg">
                            Finance Controller
                        </span>
                    </div>


                </div>



            </div>

        </div>
    </section>

    {/* HIGHLIGHTS */}
    <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">

            {/* <h2 className="text-3xl md:text-4xl font-bold text-[#08245c] mb-3">
                Vice Chancellor's Message
            </h2> */}

            {/* <p className="font-bold text-gray-700 mb-5">
                Dear Students, Faculty Members, and Esteemed Visitors,
            </p> */}

            <div className="space-y-5 text-[16px] leading-7 text-gray-700">




            </div>


        </div>
    </section>
    <Footer />

</div>
);

case "exam-controller":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5 ">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Administration
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Controller Of Examinations
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill text-lg mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    CONTROLLER OF EXAMINATIONS
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>



    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
            <div className="relative max-w-md mx-auto">

                <div className="relative overflow-hidden rounded-[28px] shadow-xl">

                    <img src="/images/Registrar_new.jpeg" alt="Prof. Satpal Singh Bisht"
                        className="block w-full h-auto  object-contain object-top" />

                    <div className="bg-[#ef4949] text-white text-center px-2 py-2">

                        <h3 className="text-xl md:text-2xl font-bold font-serif font-gill">
                            Prof. Reetesh Sah
                        </h3>

                        <p className="mt-2 text-sm md:text-base font-medium font-gill">
                            Controller Of Examinations
                        </p>

                    </div>

                </div>

            </div>

            {/* CONTENT */}
            <div>

                <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6 text-justify font-gill">
                    About Controller Of Examinations
                </h2>
                <h6 className="font-bold text-[var(--ink)] mb-6 text-justify font-gill">
                    (Prof. Reetesh Sah, Ph.D. Professor of History, Kumaun University, Nainital)
                </h6>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                    Prof. Reetesh Sah is a senior academic and institutional leader with a distinguished record in
                    scholarship, university governance and research administration. He holds a Ph.D. in History and an
                    MBA in Human Resource Management, a combination that informs his integrated approach to academic
                    leadership and faculty development.

                </p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">A recipient of an ICHR
                    Research Fellowship and two national awards from the Ministry of Defence, Government of India, he
                    has successfully led five major funded research projects supported by INSA, UGC, ICHR, and the
                    Government of Uttarakhand.</p>




                <div className="mt-8 border-t border-gray-200">

                    {/* Registrar */}
                    <div className="flex items-center gap-3 py-5 border-b border-gray-200">
                        <div className="flex-shrink-0">
                            <UserRound className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 font-gill text-lg">
                            Controller Of Examinations
                        </span>
                    </div>

                    {/* Qualification */}
                    <div className="flex items-center gap-3 py-5">
                        <div className="flex-shrink-0">
                            <GraduationCap className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 text-justify font-gill text-lg">
                            Ph.D. in History, MBA in Human Resource Management

                        </span>
                    </div>

                </div>



            </div>

        </div>
    </section>

    {/* HIGHLIGHTS */}
    <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">



            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">As a founding member of the
                    UGC–MMTTC, Kumaun University, Prof. Sah has been instrumental in faculty development and academic
                    quality assurance, contributions that helped the Centre achieve a national ranking of fourth among
                    all UGC–MMTTCs in India. </p>

                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">His governance portfolio
                    spans University P.R.O., Additional Director (IQAC), Editor of QUEST – the Journal of UGC-HRDC,
                    Assistant Dean (Students’ Welfare), Nodal Officer (Mission Karmayogi), President (Students’ Club),
                    Chief Editor (University Publicatons), and is a member of various statutory and advisory bodies. His
                    major prior administrative roles include Deputy Controller of Examinations, Proctor and
                    Superintendent of University Central Evaluation.</p>

                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">In addition to his
                    university roles, Prof. Sah contributes to public service and environmental governance. He is a
                    Member of the District Plantation Committee, Member of the District Forest Fire Committee, and a
                    member of the Technical Forestry Committee (TFC) of the Uttarakhand Forest Department, reflecting
                    his commitment to community engagement, environmental sustainability, and policy support.</p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">A prolific scholar, he has
                    authored six books, one monograph, and over fifty research papers, with publications through
                    internationally reputed publishers including Springer Nature. He has edited illustrated academic
                    volumes for the Government of Uttarakhand and Kumaun University, including for the visit of the
                    Hon’ble President of India.</p>
                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">Prof. Sah has supervised
                    eleven Ph.D. scholars and extends his mentorship through co-guidance to an Indian Army Officer at
                    Amity University. His academic outreach spans invited lectures at ICCR and leading institutions
                    including BHU, JMI, Delhi University, NBU, Jadavpur University, Gujarat University, Kashmir
                    University, Calicut University, Punjab University, Chandigarh, DAVV, Indore and MANUU Hyderabad,
                    among others. He has also delivered training for civil services officers of Uttarakhand and Bihar at
                    the Uttarakhand Academy of Administration.</p>




            </div>


        </div>
    </section>
    <Footer />

</div>
);


case "deputy-exam-controller":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5 ">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Administration
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Deputy Controller of Examinations
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill text-lg mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    DEPUTY CONTROLLER OF EXAMINATIONS
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>



    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
            <div className="relative max-w-md mx-auto">

                <div className="relative overflow-hidden rounded-[28px] shadow-xl">

                    <img src="/images/deputy-exam-controller.png" alt="Prof. Satpal Singh Bisht"
                        className="block w-full h-auto  object-contain object-top" />

                    <div className="bg-[#ef4949] text-white text-center px-2 py-2">

                        <h3 className="text-xl md:text-2xl font-bold font-serif font-gill">
                            Dr. Nandan Singh Bisht
                        </h3>

                        <p className="mt-2 text-sm md:text-base font-medium font-gill">
                            Deputy Controller of Examinations
                        </p>

                    </div>

                </div>

            </div>


            <div>

                <h2 className="text-3xl md:text-3xl font-bold text-[var(--ink)] mb-2  font-gill">
                    About Deputy Controller of Examinations
                </h2>
                <h6 className="font-bold text-[var(--ink)] mb-2 text-justify font-gill">
                    A senior Physics educator, researcher, and university administrator specializing in institutional
                    governance, examination management of Kumaun University.
                </h6>
                <section className="bg-white pt-0 pb-3">

        <div className="text-gray-700 font-gill text-base leading-6 text-justify">

            <ul className="list-disc pl-5 space-y-2">

                <li>
                    <strong className="text-red-500 font-bold">
                        Academic Expertise:
                    </strong>{" "}
                    15+ years of teaching experience at undergraduate (UG) and
                    postgraduate (PG) levels at Delhi University, Kumaun University,
                    Nainital, and SSJ University, Almora.
                </li>

                <li>
                    <strong className="text-red-500 font-bold">
                        Leadership Roles:
                    </strong>{" "}
                    Current Deputy Controller of Examinations at Kumaun University
                    (since March 2026); former In-charge Controller of Examinations
                    at SSJ University, Almora (2024–2025).
                </li>

                <li>
                    <strong className="text-red-500 font-bold">
                        Research Background & Expertise:
                    </strong>{" "}
                    20+ years of active research dedication in the field of Physics,
                    spanning the following domains:

                    <ul className="list-[circle] pl-8 mt-2 space-y-2">

                        <li>
                            <strong className="text-red-500 font-bold">
                                Doctoral Research:
                            </strong>{" "}
                            Completed Ph.D. from the National Physical Laboratory
                            (NPL), New Delhi, in collaboration with the University
                            of Delhi and IIT Delhi, focusing extensively on the
                            correlation properties of optical fields.
                        </li>

                        <li>
                            <strong className="text-red-500 font-bold">
                                Postdoctoral Research:
                            </strong>{" "}
                            Served as a Postdoctoral Fellow at the University of
                            Electro-Communications (UEC), Chofu, Tokyo, specializing
                            in experimental quantum optics and successfully
                            demonstrating broadband entangled photon pairs.
                        </li>

                        <li>
                            <strong className="text-red-500 font-bold">
                                Current Research Focus:
                            </strong>{" "}
                            Actively exploring digital holography, beam shaping,
                            polarization-sensitive imaging and microscopy for
                            biomedical applications, with additional contributions
                            to atmospheric physics and quantum optics.
                        </li>

                        <li>
                            <strong className="text-red-500 font-bold">
                                Mentoring & Supervision:
                            </strong>{" "}
                            Mentoring and supervising academic researchers at
                            Ph.D., Master's and undergraduate levels.
                        </li>

                        <li>
                            <strong className="text-red-500 font-bold">
                                Research Projects:
                            </strong>{" "}
                            Completed two major projects (SERB-DST & CMHERPS)
                            and two minor projects (UGC & UCOST).
                        </li>

                    </ul>
                </li>

            </ul>

        </div>

    </section>
                {/* <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                    Prof. Reetesh Sah is a senior academic and institutional leader with a distinguished record in
                    scholarship, university governance and research administration. He holds a Ph.D. in History and an
                    MBA in Human Resource Management, a combination that informs his integrated approach to academic
                    leadership and faculty development.

                </p>
                 */}




                <div className="mt-8 border-t border-gray-200">


                    <div className="flex items-center gap-3 py-5 border-b border-gray-200">
                        <div className="flex-shrink-0">
                            <UserRound className="w-5 h-5 text-red-600 fill-red-600" />
                        </div>

                        <span className="text-[15px] text-gray-700 font-gill text-lg">
                            Deputy Controller of Examinations
                        </span>
                    </div>


                    <div className="flex items-center gap-3 py-5">
                        {/* <div className="flex-shrink-0">
                            <GraduationCap className="w-5 h-5 text-red-600 fill-red-600" />
                        </div> */}

                        {/* <span className="text-[15px] text-gray-700 text-justify font-gill text-lg">
                            Ph.D. in History, MBA in Human Resource Management

                        </span> */}
                    </div>

                </div>



            </div>

        </div>
    </section>

    {/* HIGHLIGHTS */}

    {/* <section className="bg-white pt-0 pb-8">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-gray-700 font-gill text-lg leading-8 text-justify">

                <ul className="list-disc pl-6 space-y-4">

                    <li>
                        <strong className="text-red-500 font-bold">
                            Academic Expertise :
                        </strong>{" "}
                        15+ years of teaching experience at undergraduate (UG) and
                        postgraduate (PG) levels at Delhi University, Kumaun University,
                        Nainital, and SSJ University, Almora.
                    </li>

                    <li>
                        <strong className="text-red-500 font-bold">
                            Leadership Roles:
                        </strong>{" "}
                        Current Deputy Controller of Examinations at Kumaun University (since March 2026); former
                        In-charge Controller of Examinations at SSJ University, Almora (2024–2025).
                    </li>
                    <li>
                        <strong className="text-red-500 font-bold">
                            Research Background & Expertise:
                        </strong>{" "}
                        20+ years of active research dedication in the field of Physics, spanning the following domains:
                        <ul className="list-[circle] pl-8 mt-2 space-y-2">
                            <li>
                                <strong className="text-red-500 font-bold">Doctoral Research:</strong> Completed Ph.D.
                                from the National Physical Laboratory (NPL), New Delhi, in collaboration with the
                                University of Delhi and IIT Delhi, focusing extensively on the correlation properties of
                                optical fields.
                            </li>

                            <li>
                                <strong className="text-red-500 font-bold">Postdoctoral Research :</strong> Served as a
                                Postdoctoral Fellow at the University of Electro-Communications (UEC), Chofu, Tokyo,
                                specializing in experimental quantum optics and successfully demonstrating broadband
                                entangled photon pairs.
                            </li>

                            <li>
                                <strong className="text-red-500 font-bold">Current Research Focus :</strong> Actively
                                exploring digital holography, beam shaping, investigating polarization-sensitive imaging
                                and microscopy for biomedical applications. Additional contributions to atmospheric
                                physics, and quantum optics.
                            </li>

                            <li>
                                <strong>Mentoring and supervising academic researchers </strong> at the PhD, Master's,
                                and undergraduate levels.
                            </li>

                            <li>
                                <strong className="text-red-500 font-bold"> Research Projects : </strong> Completed two
                                major Projects (SERB-DST & CMHERPS) and Two minor Projects (UGC & UCOST)
                            </li>
                        </ul>
                    </li>


                </ul>

            </div>

        </div>
    </section> */}

    <Footer />

</div>
);

case "other-official":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        University Officials
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill text-lg mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    UNIVERSITY OFFICIALS
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>
    {/* HIGHLIGHTS */}
    <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">



            </div>

            <div className="grid md:grid-cols-3 gap-6">

  {/* ================= CORE VALUE ================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                    group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                overflow-hidden
                                bg-[#EAF5EF]
                                shadow-sm
                                group-hover:shadow-lg
                                transition-all duration-300
                            ">
                            <img src="/images/R_Vishvakarma-1725352747.png" alt="Mr. R. K. Vishvakarma"
                                className="
                                    w-full h-full
                                    object-cover
                                    object-top
                                    transition-all duration-300
                                    group-hover:scale-110
                                " />
                        </div>

                    </div>
                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill text-lg">
                        Mr. R. K. Vishvakarma
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">
                                Assistant Registrar (Affiliation)
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">University Officials</p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>Kumaun University</p>
                        </div> */}

                    </div>

                </div>

                {/* ================= MISSION ================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                    group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/AR Shamsher Singh-1726202414.png" alt="Mr. Shamsher Singh"
                                className="
                                        w-full h-full
                                        object-cover
                                        object-center
                                        transition-all duration-300
                                        group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill text-lg">
                        Mr. Shamsher Singh
                    </h3>

                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">
                                Assistant Registrar (General) of Kumaun University,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">University Officials</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">Kumaun University</p>
                        </div>

                    </div>

                </div>
                {/* ================= VISION ================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715249787.png" alt="Dr. Brijmohan Pharswan"
                                className="
                                        w-full h-full
                                        object-cover
                                        object-top
                                        transition-all duration-300
                                        group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill text-lg">
                        Dr. Brijmohan Pharswan
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">
                                Assistant Registrar (Degree) of Kumaun University,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="font-gill text-lg">University Officials</p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>Kumaun University</p>
                        </div> */}

                    </div>


                </div>


                

              
                


            </div>
        </div>
    </section>
    {/* ================= ORGANOGRAM SECTION ================= */}
    <section className="bg-[#F5F7FA] py-16">
        <div className="max-w-7xl mx-auto px-6">

            {/* Section Heading */}
            <h2 className="text-3xl md:text-4xl font-bold text-[#123B5D] mb-8 font-gill text-lg">
                Organogram (Governance)
            </h2>

            {/* Image Box */}
            <div className="bg-white rounded-2xl shadow-md border border-gray-200 p-4 md:p-6 overflow-hidden">

                <img src="/images/organogram.jpeg" alt="Organogram (Governance)"
                    className="
                    w-full
                    h-auto
                    object-contain
                    mx-auto
                    rounded-lg
                " />

            </div>

        </div>
    </section>
    <Footer />

</div>
);




default:
return (
<div className="min-h-screen flex items-center justify-center">
    <h1 className="text-3xl font-bold">
        Page Not Found
    </h1>
</div>
);
}
};


/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
return (
<div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
    <div className="flex justify-center text-[var(--terracotta)] mb-3">
        {icon}
    </div>

    <div className="text-2xl font-bold text-[var(--ink)]">
        {value}
    </div>

    <div className="text-sm text-gray-500 mt-1">
        {label}
    </div>
</div>
);
};


/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
return (
<div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
    <h3 className="text-xl font-bold text-[var(--ink)] mb-3">
        {title}
    </h3>

    <p className="text-gray-600 leading-7">
        {text}
    </p>
</div>
);

};

export default AboutPage;
